// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ButtonGroup_buttons__Xl6C2"};